module.exports = __webpack_public_path__ + "img/GIS-TL_接水点.d1afd4e0.png";